import { HandoverTypeEnum } from '../../enum/handover-type.enum';
import { VariationTypeEnum } from '../../enum/variation-type.enum';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class CreateVariationCommand {
  VariationId: string;
  HandoverId: string;
  HandoverType: HandoverTypeEnum;
  SiteId: string;
  CustomerId: string;
  VariationType: VariationTypeEnum;
  CommandVersion: string;
  SourceApp: string;
  SourceAppVersion: string;
}


